module.exports = "/images/logo.webp?b1d7b184b3cbe99e423d4439e2835819";